module.exports = require("./smn.d.ts");